import {remCalc} from '../../_utils'

export default {
    baseStyle: ({basketLength}: {basketLength: number}) => ({
        orderSummaryBox: {
            w: {base: '100%'},
        },
        summaryContainer: {
            display: 'flex',
            paddingY: remCalc(16),
            paddingX: remCalc(24),
            gap: remCalc(0),
            flexDir: 'column',
            borderRadius: 'medium.lg',
            bg: 'background.light',
            minWidth: {lg: 'unset', xl: remCalc(451)},
        },
        promo: {
            promoContainer: {
                width: 'full',
                display: 'flex',
                p: remCalc(24),
                flexDir: 'column',
                borderRadius: ['medium.lg', 'medium.md', 'medium.sm', 'medium.base'],
                bg: 'background.light',
                marginBottom: remCalc(8),
            },
        },
        summaryHeader: {
            itemContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(10),
                alignSelf: 'stretch',
                paddingTop: {base: remCalc(10), lg: remCalc(12)},
                paddingBottom: {base: remCalc(10), lg: remCalc(12)},
            },
            headerText: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 500,
            },
        },
        subtotalSection: {
            subtotalPriceContainer: {
                display: 'flex',
                flexDir: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                paddingY: remCalc(12),
            },
            subtotalContainer: {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                paddingTop: {base: remCalc(12), lg: remCalc(12)},
                paddingBottom: {base: remCalc(12), lg: remCalc(12)},
                gap: remCalc(8),
            },
            subtotalStackContainer: {
                flex: 1,
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            },
            subtotalText: {
                color: 'text.default',
                textStyle: 'body-small',
                fontWeight: 400,
            },
            freeShippingText: {
                color: 'text.success',
                textStyle: 'body-small',
            },
            infoIconContainer: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // border: remCalc(1),
                // borderStyle: 'solid',
                // borderColor: 'border.dark',
                borderRadius: '50%',
            },
            infoIcon: {
                w: 'iconsSize.small',
                h: 'iconsSize.small',
                color: 'text.default',
                fill: 'none',
            },
            shippingEstimationn: {
                color: 'text.default',
                textStyle: 'body-xsmall',
                fontWeight: 400,
            },
            savedAmountContainer: {
                textStyle: 'body-small',
                alignItems: 'center',
                justifyContent: 'space-between',
                py: remCalc(12),
            },
        },
        checkoutSection: {
            checkoutContainer: {
                display: 'flex',
                paddingTop: remCalc(16),
                flexDir: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
                gap: remCalc(8),
            },
            totalText: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 700,
            },
            klarnaText: {
                color: 'text.default',
                textStyle: 'body-xsmall',
                fontWeight: 400,
            },
            goToCheckoutButtonContainer: {
                position: {base: 'fixed', lg: 'unset'},
                left: '0',
                bottom: '0',
                width: '100%',
                background: {base: 'background.light', lg: 'unset'},
                px: {base: 'small.base', lg: 'unset'},
                paddingTop: 'small.base',
                paddingBottom: 'xsmall.base',
                zIndex: '3',
            },
            goToCheckoutButtonContainerSticky: {
                paddingTop: remCalc(0),
                paddingBottom: remCalc(16),
            },
            goToCheckout: {
                width: '100%',
                _hover: {
                    textDecoration: 'none',
                    bg: 'button.text.text-hover',
                },
            },
            checkoutTotalContainer: {
                display: {base: 'flex', lg: 'none'},
                pb: 'xsmall.base',
            },
            vatInCheckoutButton: {
                textStyle: 'body-xxsmall',
                pl: 'xsmall.base',
                alignSelf: 'center',
            },
        },
        promoCode: {
            inputContainer: {
                display: 'flex',
                flexDir: 'column',
                minWidth: remCalc(140),
                paddingY: 0,
                gap: 'small.base',
                alignSelf: 'stretch',
                w: '100%',
            },
            inputContainerHeader: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 500,
                mb: 'xsmall.base',
            },
            applyButton: {
                variant: 'text-button',
                marginLeft: 'xsmall.base',
            },
            inputProps: {
                display: 'flex',
                minHeight: remCalc(40),
                paddingX: 'xsmall.base',
                paddingY: 'small.base',
                // justifyItems: 'center',
                // alignSelf: 'stretch',
                borderRadius: ['medium.lg', 'medium.md', 'medium.sm', 'medium.base'],
                bg: 'background.default',
            },
            referralLink: {
                color: 'button.text.text-default',
                textStyle: 'body-small',
                fontWeight: 400,
                textOverflow: 'ellipsis',
                textDecorationLine: 'underline',
                textDecorationStyle: 'solid',
                'text-decoration-skip-ink': 'none',
                textDecorationThickness: 'auto',
                textUnderlineOffset: 'auto',
                flex: '1 1 0',
            },
            textContainer: {
                alignItems: 'center',
                justifyContent: 'space-between',
            },
            couponSuccessContainer: {
                alignItems: 'center',
                justifyContent: 'center',
                gap: {
                    base: 'xsmall.base',
                    sm: 'xsmall.sm',
                },
            },
            textCoupon: {
                textStyle: 'body-small',
                color: 'text.success',
                fontWeight: 400,
            },
            couponSuccessIcon: {
                w: 'iconsSize.medium',
                h: 'iconsSize.medium',
                color: 'text.success',
            },
        },
        cartItems: {
            container: {
                // py: remCalc(12),
                // pt: remCalc(4),
                pt: remCalc(8),
                maxHeight: remCalc(300),
                overflowY: basketLength >= 2 ? 'scroll' : 'none',
                '::-webkit-scrollbar': {
                    width: remCalc(6),
                },
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'button.border.inverse-primary-focused',
                    borderRadius: remCalc(6.5),
                },
            },
            itemsText: {
                textStyle: 'body-small',
            },
            itemsContainer: {
                // paddingBottom: remCalc(24),
                pt: remCalc(16),
                w: '100%',
            },
            innerItemContainer: {
                // minWidth: remCalc(109),
                width: 'full',
                alignItems: 'flex-start',
                gap: remCalc(16),
                // mb: remCalc(16),
            },
            stack: {
                // width: 'full',
                gap: remCalc(16),
            },
            itemVariant: {
                textStyle: 'body-medium',
                fontWeight: 'bold',
            },
            stackContent: {
                flexDirection: 'column',
                gap: remCalc(4),
            },
            itemVariantAttributes: {
                textStyle: 'body-xsmall',
            },
        },
    }),
    variants: {
        checkout: {
            orderSummaryBox: {
                p: `0 ${remCalc(24)} ${remCalc(24)}`,
            },
            summaryContainer: {
                paddingY: 'unset',
                paddingX: 'unset',
            },
            summaryHeader: {
                itemContainer: {
                    display: 'none',
                },
            },
            cartItems: {
                container: {
                    pb: 'unset',
                },
                itemsContainer: {
                    pt: 'unset',
                },
            },
        },
    },
}
